<!--<ng-container >

    <app-recap-info-general-fournisseur
[id]="id"
    [dataMandataire]="dataMandataire"
    [dataAgrement]="dataAgrement"
    [dataProduit]="dataProduit"
    [datausine]="datausine" 
    [data2]="data2" 
    [data]="data" 
    [langue]="langue"
    ></app-recap-info-general-fournisseur>

</ng-container>-->



<app-etat-inscription-fourn [bizRegNo]="id"></app-etat-inscription-fourn>